const termOptions: { [key: string]: string } = {
  12: '12 Months',
  24: '24 Months',
  36: '36 Months',
  48: '48 Months',
  60: '60 Months',
};

export default termOptions;
